import { createApp } from "vue";

import "@fortawesome/fontawesome-free/css/all.min.css";

import "vue-multiselect/dist/vue-multiselect.css";
import "@/assets/scss/main.scss";
import App from "./App.vue";
import store from "./store";

import routerGuest from "@/router/guest";
import router from "@/router/internal";

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";

import "@/assets/scss/material-dashboard.scss";
import "@/assets/scss/datepicker.scss";

import { createPinia } from "pinia";
const pinia = createPinia();

import { RegleVuePlugin } from "@regle/core";
import { initTenantGuard, pinTabTenant } from "@/utils/tenantGuard";
import { decodeJwt } from "@/utils/jwt";
import { startSession } from "@/services/session";

async function main() {
  const accessToken = localStorage.getItem("accessToken");

  const appInstance = createApp(App);
  appInstance.use(store);

  appInstance.use(pinia);
  appInstance.use(RegleVuePlugin);

  if (accessToken) {
    const decoded = decodeJwt(accessToken);

    console.log("new deployment ✅");

    if (!decoded) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("localUser");
      localStorage.removeItem("showDevFeatures");
      localStorage.removeItem("showAdminArea");
      window.location.href = "/";
      return;
    }

    const exp = decoded.exp * 1000;
    const isExpired = Date.now() > exp;

    if (isExpired) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("localUser");
      localStorage.removeItem("showDevFeatures");
      localStorage.removeItem("showAdminArea");
      window.location.href = "/authentication/signin?reason=jwtExpired";
      return;
    }

    const defaultPermissionsMap = {
      devFeatures: false,
      adminArea: false,
    };

    const localUser = {
      expiresIn: decoded.exp * 1000,
      phoneNumber: decoded.phoneNumber,
      userId: decoded.userId,
      rolesMap: decoded.rolesMap,
      accessMap: decoded.accessMap || null,
      tenantName: decoded.tenantName,
      permissionsMap: decoded.permissionsMap || defaultPermissionsMap,
    };

    localStorage.setItem("localUser", JSON.stringify(localUser));

    // Pin this tab to the tenant of the token it was opened with, then watch for
    // token changes from other tabs. This prevents actions in this tab from
    // silently writing to a different tenant if another tab logs in.
    pinTabTenant(decoded.tenantName);
    initTenantGuard();

    const showDevFeatures = localUser.permissionsMap?.devFeatures ? "y" : "";
    const showAdminArea = localUser.permissionsMap?.adminArea ? "y" : "";
    localStorage.setItem("showDevFeatures", showDevFeatures);
    localStorage.setItem("showAdminArea", showAdminArea);

    startSession(localUser);

    appInstance.use(router);
  } else {
    localStorage.setItem("localUser", "");
    localStorage.setItem("showDevFeatures", "");
    localStorage.setItem("showAdminArea", "");

    appInstance.use(routerGuest);
  }

  appInstance.mount("#app");
}

main();
